import { useCallback, useEffect, useState } from "react";
import { Post } from "../services/api";
import { toast } from "react-toastify";
import { formatDigit } from "./format.util";
import { ModifyOrderModal } from "./EditOrder";

const PendingOrders = ({ side, refresh, refreshPage, socket = { socket } }) => {
  const [EditModel, set_EditModel] = useState(false);
  const [price, set_price] = useState("");
  const [quantity, set_quantity] = useState("");
  const [type, set_type] = useState("");
  const [trade_id, set_trade_id] = useState();
  const [pair, set_pair] = useState();

  const closeModel = useCallback(() => {
    set_EditModel(false);
  }, []);

  const onClickEdit = (price, quantity, type, trade_id, pair) => {
    set_EditModel(true);
    set_price(price);
    set_quantity(quantity);
    set_type(type);
    set_trade_id(trade_id);
    set_pair(pair);
  };

  const [orders, set_orders] = useState([]);

  useEffect(() => {
    if (!localStorage.getItem("jwtToken")) return;

    socket.emit(
      "get_orders",
      { side: side.toUpperCase(), status: "Pending" }, // same case as Zod expects
      (response) => {
        if (response?.status) {
          set_orders(response.orders);
        } else {
          toast.error("Failed to completed Orders");
        }
      }
    );
  }, [refresh, side]);

  const [deleteLoader, set_deleteLoader] = useState(0);

  const delete_order = (order_id, pair) => {
    if (deleteLoader > 0) {
      return toast.error("Delete request is Already in Pending");
    }

    set_deleteLoader(order_id);

    if (!localStorage.getItem("jwtToken")) {
      toast.error("You must be logged in");
      return set_deleteLoader(0);
    }

    // Emit to socket instead of HTTP POST
    socket.emit(
      "delete_order", // backend socket event name
      {
        order_id: String(order_id), // zod expects string
        pair: pair.toUpperCase(), // e.g. "ETH/USDT"
      },
      (response) => {
        // Socket callback

        console.log(response, "dlete_order_response");
        if (response.status) {
          set_orders((prev) =>
            prev.filter((o) => String(o.order_id) !== String(order_id))
          );
          if (typeof refreshPage === "function") refreshPage();
          if (response.final_status === "filled") {
            toast.info(
              response.message || "Order was already filled before cancel"
            );
          }
        } else {
          toast.error(response.message || "Failed to delete order");
        }
        set_deleteLoader(0);
      }
    );
  };

  return (
    <>
      <div className="tab-pane active" id="pending" role="tabpanel">
        <ModifyOrderModal
          EditModel={EditModel}
          closeModel={closeModel}
          type={type} // "Buy" or "Sell"
          price={price}
          quantity={quantity}
          trade_id={trade_id}
          refreshPage={refreshPage}
          pair={pair}
          socket={socket}
        />

        <div className="userRecords-main obo_exchange">
          <table className="table mb-0">
            <thead>
              <tr>
                <th className="f-left ng-binding">Pair</th>
                <th className="f-left ng-binding">Price</th>
                <th className="f-left ng-binding">Amount</th>
                <th className="f-left ng-binding">Total</th>
                <th className="f-left ng-binding">Date & Time</th>
                <th className="f-center cancels">
                  <span className="ng-binding p-0">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              ) : (
                orders.map((e, i) => (
                  <tr className="ng-scope" key={i}>
                    <td className="f-left ng-binding ">{e.pair}</td>
                    <td className="f-left ng-binding ">
                      {formatDigit(e.price)}
                    </td>
                    <td
                      style={{
                        color: e.side === "SELL" ? "red " : "green ", // Added !important to force override
                      }}
                    >
                      {formatDigit(e.quantity)}
                    </td>
                    <td className="f-left ng-binding">
                      {formatDigit(e.trade_total)}
                    </td>
                    <td className="f-left ng-binding green">
                      {e.created_at || null}
                    </td>
                    <td className="f-left ng-binding">
                      {/* {!e.binance_order_id && (
                          <button
                            className="btn  mr-2"
                            // onClick={() => updateSellOrder(e.sell_id, "sell")}
                            // disabled={updateAndDeleteButton}
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                        )} */}
                      <button
                        disabled={e.order_id == deleteLoader}
                        className="btn"
                        onClick={() => delete_order(e.order_id, e.pair)}
                        // disabled={updateAndDeleteButton}
                      >
                        <i className="fa fa-trash" aria-hidden="true"></i>
                      </button>
                      {e.provider == "Self" &&
                      String(e.is_partial || "N").toUpperCase() !== "Y" ? (
                        <button
                          className="btn "
                          onClick={() =>
                            onClickEdit(
                              formatDigit(e.price),
                              formatDigit(e.quantity),
                              side,
                              e.order_id,
                              e.pair
                            )
                          }
                          // disabled={updateAndDeleteButton}
                        >
                          <i className="fa fa-edit" aria-hidden="true"></i>
                        </button>
                      ) : null}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export { PendingOrders };
